import { useLocation, useNavigate } from 'react-router-dom';

type ReturnRouteState = { returnTo?: string } | null;

export const useNavigateWithReturn = () => {
  const navigate = useNavigate();
  const { pathname, search, state } = useLocation();
  const returnTo =
    (state as ReturnRouteState)?.returnTo ?? `${pathname}${search}`;
  return (to: string) => navigate(to, { state: { returnTo } });
};

export const useNavigateKeepingReturn = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const returnTo = (state as ReturnRouteState)?.returnTo;
  return (to: string) =>
    navigate(to, { state: returnTo ? { returnTo } : undefined });
};

export const useReturnRoute = (fallbackRoute: string) => {
  const { state } = useLocation();
  return (state as ReturnRouteState)?.returnTo ?? fallbackRoute;
};
